module.exports = __webpack_public_path__ + "static/img/sec1-main-img@m.e20d69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec1-main-img@m.jpg
// module id = u2a8
// module chunks = 0